import { SupportChatMessage, GroupedMessage } from '@caks/shared/types/types.api'

export const groupMessages = (messages: SupportChatMessage[]): GroupedMessage[] => {
  const groupped: GroupedMessage[] = messages.reduce((acc: GroupedMessage[], message) => {
    const date = new Date(message.sent_at).toISOString().slice(0, 10)
    const existingGroup = acc.find((group) => group.date === date)

    if (existingGroup) {
      existingGroup.messages.push(message)
    } else {
      acc.push({
        id: acc.length + 1,
        date,
        messages: [message],
      })
    }

    return acc
  }, [])

  return groupped.map((el) => {
    return { ...el, messages: el.messages.reverse() }
  })
}

export const formatGroupDate = (dateString: string) => {
  const date = new Date(dateString)

  const daysOfWeek = [
    'Воскресенье',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
  ]
  const dayOfWeek = daysOfWeek[date.getDay()]

  return `${dayOfWeek} ${date.toLocaleDateString()}`
}
